import { request } from '@/utils/request.js';

/**
 * 二筛评估功能 Mixin
 * 使用 Dify 进行心理评估，不再查询数据库
 */
export default {
    data() {
        return {
            isAssessmentMode: false, // 是否处于评估模式
            isAssessmentWaiting: false, // 是否正在等待 Dify 的评估问题
        };
    },

    methods: {
        // 启动评估模式
        async assessmentStartMode() {
            this.isAssessmentMode = true;
            this.isAssessmentWaiting = true;

            // 发送初始消息给 Dify 开始心理评估
            this.messages.push({
                type: 'user',
                content: '进行心理评估',
            });

            // 调用 Dify 获取第一个问题
            await this.assessmentSendToDify('进行心理评估');
        },

        // 发送消息给 Dify（评估模式专用，使用阻塞式请求）
        async assessmentSendToDify(message) {
            const msgIndex = this.messages.length;
            this.messages.push({ type: 'thinking' });
            this.chatScrollToBottom();

            try {
                const res = await request({
                    url: '/api/send-message',
                    method: 'POST',
                    data: {
                        message: message,
                        conversationId: this.chatConversationId,
                        isAssessment: true,
                    },
                });

                const data = res.data;
                if (data.code === 200) {
                    const reply = data.data.difyReply || '';
                    const audioUrl = data.data.audioUrl;

                    // 用打字机效果展示文字
                    this.chatStartTypewriter(reply, msgIndex, () => {
                        // 打字机结束后不做额外处理
                    });

                    // 更新会话ID
                    if (data.data.conversationId) {
                        this.chatConversationId = data.data.conversationId;
                    }

                    this.isAssessmentWaiting = false;

                    // 播放语音
                    if (audioUrl) {
                        this.audioPlay(audioUrl);
                    }

                    // 如果是报告完成，延迟弹出弹窗
                    if (data.data.isReport) {
                        setTimeout(() => {
                            this.assessmentFinish();
                        }, 1500);
                    }
                } else {
                    this.$set(this.messages, msgIndex, {
                        type: 'bot',
                        content: data.message || '抱歉，获取问题失败，请重试~',
                    });
                    this.isAssessmentWaiting = false;
                    this.$toast(data.message || '获取失败');
                }
            } catch (err) {
                console.error('评估请求失败:', err);
                this.$set(this.messages, msgIndex, {
                    type: 'bot',
                    content: '网络错误，请重试~',
                });
                this.isAssessmentWaiting = false;
                this.$toast('网络错误，请重试');
            }
        },

        // 提交评估答案
        async assessmentSubmitAnswer(answer) {
            if (!this.isAssessmentMode) return;

            // 发送格式：进行心理评估：用户的回复
            const assessmentMessage = `进行心理评估：${answer}`;

            // 继续发送给 Dify 获取下一个问题
            await this.assessmentSendToDify(assessmentMessage);
        },

        // 完成评估：结束会话、清空消息并提示进入聊天模式
        async assessmentFinish() {
            this.isAssessmentMode = false;
            this.isAssessmentWaiting = false;

            // 停止音频和打字机效果
            this.audioStop();
            this.chatStopTypewriter();
            if (this.chatThinkingTimer) {
                clearTimeout(this.chatThinkingTimer);
                clearInterval(this.chatThinkingTimer);
                this.chatThinkingTimer = null;
            }

            // 结束当前会话
            if (this.chatConversationId) {
                try {
                    await request({
                        url: '/api/end-conversation',
                        method: 'POST',
                        data: { conversationId: this.chatConversationId },
                    });
                } catch (e) {
                    console.error('标记会话结束失败:', e);
                }
            }

            // 清空会话ID和消息列表
            this.chatConversationId = '';
            this.messages = [];

            // 显示完成弹窗，确认后显示默认欢迎语
            this.$dialog
                .alert({
                    title: '评估完成',
                    message:
                        '感谢您的配合！评估已完成，现在将为您开启正常聊天模式。',
                    confirmButtonText: '开始聊天',
                })
                .then(() => {
                    this.chatShowDefaultWelcome();
                })
                .catch(() => {});
        },
    },
};
